var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-wrapper",class:{ small: _vm.small, large: _vm.large },on:{"click":_vm.redirectHome}},[_c('img',{staticClass:"logo-image",attrs:{"src":_vm.logo,"alt":"Dremca Insurance Logo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }